/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { DropdownModule } from 'primeng/dropdown';


@Component({
  selector: 'app-selection-field',
  templateUrl: './selection-field.component.html',
  styleUrls: ['./selection-field.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, DropdownModule, TranslocoDirective],
})
export class SelectionFieldComponent implements OnInit{

  @Input() placeholder: string = '';
  @Input() title: string = '';
  @Input() bindValue: string = '';
  @Input() bindLabel: string = '';
  @Input() filterFields: string[] = [];
  @Input() disabled: boolean = false
  @Input() isCapitalRequired: boolean = false;
  @Input() showClear: boolean = false;
  @Input() remark: string = '';
  @Input() showRemarks = false
  @Input() setDefault = false
  @Input() editable = false
  /** 'body' floats the list above the page, so it is not cut off when the field is last on the page. */
  @Input() appendTo: any = null;

  
  @Output() valueChange = new EventEmitter<any>();

  @Input() filter: boolean = true;
  @Input() validator: object = {
    status: ''
  };
  @Input() field: any = '';
  @Input() model = {

  };

  @Input() isArray: boolean = false;
  @Input() index: number = 0;


  @Input() options = []

  @Input() altomateStyle: string = 'margin-bottom: 20px; width: 100%;';


  dropdownPanelStyle = {
    // 'margin-left': '-6px',
    'margin-top': '3px'
  };

  ngAfterViewInit() {
    // class="ng-star-inserted"
    // const insertedElements = document.querySelectorAll('.ng-star-inserted');

    // insertedElements.forEach((element) => {
    //   console.log(element);
    //   (element as HTMLElement).style.color = 'yellow !important';
    // });


    // console.log(insertedElements)
    // document.get
  }

  ngOnInit() {
    console.log(this.setDefault)
    console.log(this.options)

    if(this.setDefault === true) {
       if (this.isArray) {
      this.model[this.field][this.index] = this.options[0][this.bindValue];
    } else {
      this.model[this.field] = this.options[0][this.bindValue];
    }
    }
  }

  // Handle input change
  onChange(event: any) {
    this.validator = {}
    this.valueChange.emit(event);
  }


  get boundModel() {
    return this.isArray ? this.model[this.field][this.index] : this.model[this.field];
  }


  set boundModel(value) {
    if (this.isArray) {
      this.model[this.field][this.index] = value;
    } else {
      this.model[this.field] = value;
    }
  }



}